module.exports = __webpack_public_path__ + "static/img/arthroscopy-07.6d31a1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-07.jpg
// module id = ottW
// module chunks = 52